var _defs, _path, _path2, _g, _path3, _path4, _g2, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIran(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 19.2,
    viewBox: "0 0 28 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#da0000}.prefix__cls-3{fill:#fff}.prefix__cls-9{fill:#a00000}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__iran",
    transform: "translate(.14 -77.6)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_331",
    d: "M0 304.8v3.651a2.722 2.722 0 0 0 2.7 2.749h22.54a2.722 2.722 0 0 0 2.7-2.749V304.8z",
    className: "prefix__cls-1",
    "data-name": "Path 331",
    transform: "translate(-.112 -214.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_332",
    d: "M25.24 77.6H2.7A2.722 2.722 0 0 0 0 80.349V84h27.944v-3.651A2.722 2.722 0 0 0 25.24 77.6z",
    "data-name": "Path 332",
    transform: "translate(-.112)",
    style: {
      fill: "#239f40"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_284",
    d: "M0 0H28V6H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 284",
    transform: "translate(-.14 83.8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_333",
    d: "M322.682 311.2a2.722 2.722 0 0 0 2.7-2.749V304.8H315.2z",
    "data-name": "Path 333",
    transform: "translate(-297.554 -214.4)",
    style: {
      fill: "#c10000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_334",
    d: "M70.535 77.6H48l7.482 6.4H73.24v-3.651a2.722 2.722 0 0 0-2.705-2.749z",
    "data-name": "Path 334",
    transform: "translate(-45.408)",
    style: {
      fill: "#138e2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_335",
    d: "M187.662 196.18H197.8v-6.58H180z",
    "data-name": "Path 335",
    transform: "translate(-169.971 -105.69)",
    style: {
      fill: "#f7f4e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_336",
    d: "M70.535 77.6H48L68.868 84h4.372v-3.651a2.722 2.722 0 0 0-2.705-2.749z",
    "data-name": "Path 336",
    transform: "translate(-45.408)",
    style: {
      fill: "#097218"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_337",
    d: "M419 191v-1.4h-4.6z",
    "data-name": "Path 337",
    transform: "translate(-391.166 -105.69)",
    style: {
      fill: "#f2e9c2"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_199",
    "data-name": "Group 199",
    transform: "translate(-.112 84.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_338",
    d: "M27.944 369.6a2.722 2.722 0 0 1-2.7 2.749H2.7A2.722 2.722 0 0 1 0 369.6",
    className: "prefix__cls-9",
    "data-name": "Path 338",
    transform: "translate(0 -359.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_339",
    d: "M268.8 210.4a2.926 2.926 0 0 1 .541 4.011 2.18 2.18 0 0 0-.541-4.011z",
    className: "prefix__cls-9",
    "data-name": "Path 339",
    transform: "translate(-253.656 -209.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_340",
    d: "M235.356 198.806a.421.421 0 0 0 .721-.406c-.361.631-.721.135-.721.135s-.361.5-.721-.135a.418.418 0 0 0 .721.406z",
    className: "prefix__cls-9",
    "data-name": "Path 340",
    transform: "translate(-221.384 -198.4)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_341",
    d: "M218.878 210.208a2.484 2.484 0 0 0-.9-2.028 2.928 2.928 0 0 1-.676 3.921l.09-2.208v-1.623a1.435 1.435 0 0 1-.361-.27s-.225.27-.361.27v1.623l.09 2.208a2.876 2.876 0 0 1-.676-3.921 2.378 2.378 0 0 0-.9 2.028 2.716 2.716 0 0 0 1.352 2.3 2.866 2.866 0 0 1-1.082.18 2.167 2.167 0 0 0 1.307.09l.225.315.225-.315a2.194 2.194 0 0 0 1.307-.09 2.144 2.144 0 0 1-1.082-.18 2.715 2.715 0 0 0 1.442-2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 341",
    transform: "translate(-203.17 -123.053)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__SVGCleanerId_0",
    d: "M199.668 210.4a2.18 2.18 0 0 0-.541 4.011 2.905 2.905 0 0 1 .541-4.011z",
    className: "prefix__cls-1",
    transform: "translate(-186.981 -125.318)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_200",
    "data-name": "Group 200",
    transform: "translate(12.327 84.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_342",
    d: "M264.8 211.2a2.971 2.971 0 0 1 .135 2.975l.406.361a2.351 2.351 0 0 0 .361-1.307 2.378 2.378 0 0 0-.902-2.029z",
    className: "prefix__cls-9",
    "data-name": "Path 342",
    transform: "translate(-262.321 -211.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_343",
    d: "M220.8 211.966l.225.18a2.73 2.73 0 0 1 .406-.946 1.607 1.607 0 0 0-.631.766z",
    className: "prefix__cls-9",
    "data-name": "Path 343",
    transform: "translate(-220.8 -211.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_344",
    d: "M242.321 209.893v-1.623a1.435 1.435 0 0 1-.361-.27s-.225.27-.361.27v1.713l.676.541z",
    className: "prefix__cls-9",
    "data-name": "Path 344",
    transform: "translate(-240.428 -208)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_201",
    "data-name": "Group 201",
    transform: "translate(11.044 85.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__SVGCleanerId_0_1_",
    d: "M199.668 210.4a2.18 2.18 0 0 0-.541 4.011 2.905 2.905 0 0 1 .541-4.011z",
    className: "prefix__cls-1",
    transform: "translate(-198.025 -210.4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_202",
    "data-name": "Group 202",
    transform: "translate(.023 82.783)",
    style: {
      opacity: 0.5
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_285",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 285",
    transform: "translate(12.485)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_345",
    d: "M249.927 170.141h-.09v-.541h-.18v.541h-.135v-.541h-.18v.27h-.542v.451h.451v-.18h-.27v-.09h.361v.27h.766v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 345",
    transform: "translate(-234.918 -169.6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_286",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 286",
    transform: "translate(12.755 .541)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_346",
    d: "M224.18 174.58h.406v.27h.721v-.45h-.451v.18h.27v.09h-.361v-.27H224v.451h.18z",
    className: "prefix__cls-3",
    "data-name": "Path 346",
    transform: "translate(-211.515 -174.13)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_287",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 287",
    transform: "translate(13.882 .856)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_288",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 288",
    transform: "translate(12.485 .856)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_289",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 289",
    transform: "translate(12.485 8.113)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_347",
    d: "M224.856 318.58h.27v.09h-.361v-.27H224v.451h.18v-.27h.406v.27h.721v-.451h-.451z",
    className: "prefix__cls-3",
    "data-name": "Path 347",
    transform: "translate(-211.515 -310.017)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_348",
    d: "M249.927 314.141h-.09v-.541h-.18v.541h-.135v-.541h-.18v.27h-.542v.451h.451v-.18h-.27v-.09h.361v.27h.766v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 348",
    transform: "translate(-234.918 -305.487)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_290",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 290",
    transform: "translate(12.755 8.654)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_291",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 291",
    transform: "translate(13.882 7.797)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_292",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 292",
    transform: "translate(12.485 7.797)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_293",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 293",
    transform: "translate(15.279)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_349",
    d: "M299.482 170.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27h-.542v.451h.451v-.18h-.27v-.09h.361v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 349",
    transform: "translate(-281.724 -169.6)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_294",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 294",
    transform: "translate(15.549 .541)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_350",
    d: "M273.78 174.58h.361v.27h.766v-.45h-.5v.18h.315v.09h-.406v-.27h-.716v.451h.18z",
    className: "prefix__cls-3",
    "data-name": "Path 350",
    transform: "translate(-258.321 -174.13)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_295",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 295",
    transform: "translate(15.279 .856)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_296",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 296",
    transform: "translate(16.676 .856)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_351",
    d: "M274.411 318.58h.315v.09h-.406v-.27h-.72v.451h.18v-.27h.361v.27h.766v-.451h-.5z",
    className: "prefix__cls-3",
    "data-name": "Path 351",
    transform: "translate(-258.321 -310.017)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_352",
    d: "M299.482 314.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27h-.542v.451h.451v-.18h-.27v-.09h.361v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 352",
    transform: "translate(-281.724 -305.487)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_297",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 297",
    transform: "translate(15.549 8.654)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_298",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 298",
    transform: "translate(15.279 8.113)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_299",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 299",
    transform: "translate(16.676 7.797)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_300",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 300",
    transform: "translate(15.279 7.797)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_353",
    d: "M125.78 174.58h.361v.27h.721v-.45h-.451v.18h.315v.09h-.406v-.27h-.72v.451h.18z",
    className: "prefix__cls-3",
    "data-name": "Path 353",
    transform: "translate(-118.659 -174.13)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_354",
    d: "M151.482 170.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27h-.542v.451h.451v-.18h-.27v-.09h.361v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 354",
    transform: "translate(-142.062 -169.6)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_301",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 301",
    transform: "translate(6.941)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_302",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 302",
    transform: "translate(7.211 .541)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_303",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 303",
    transform: "translate(6.941 .856)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_304",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 304",
    transform: "translate(8.338 .856)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_305",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 305",
    transform: "translate(7.211 8.654)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_355",
    d: "M151.482 314.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27h-.542v.451h.451v-.18h-.27v-.09h.361v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 355",
    transform: "translate(-142.062 -305.487)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_306",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 306",
    transform: "translate(6.941 8.113)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_356",
    d: "M126.411 318.58h.315v.09h-.406v-.27h-.72v.451h.18v-.27h.361v.27h.721v-.451h-.451z",
    className: "prefix__cls-3",
    "data-name": "Path 356",
    transform: "translate(-118.659 -310.017)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_307",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 307",
    transform: "translate(6.941 7.797)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_308",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 308",
    transform: "translate(8.338 7.797)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_309",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 309",
    transform: "translate(9.735)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_310",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 310",
    transform: "translate(10.006 .541)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_357",
    d: "M200.327 170.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27h-.587v.451h.5v-.18h-.315v-.09h.406v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 357",
    transform: "translate(-188.113 -169.6)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_358",
    d: "M175.38 174.58h.361v.27h.721v-.45h-.451v.18h.27v.09h-.361v-.27h-.72v.451h.18z",
    className: "prefix__cls-3",
    "data-name": "Path 358",
    transform: "translate(-165.465 -174.13)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_311",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 311",
    transform: "translate(11.087 .856)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_312",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 312",
    transform: "translate(9.735 .856)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_313",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 313",
    transform: "translate(9.735 8.113)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_359",
    d: "M200.327 314.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27h-.587v.451h.5v-.18h-.315v-.09h.406v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 359",
    transform: "translate(-188.113 -305.487)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_360",
    d: "M176.011 318.58h.27v.09h-.361v-.27h-.72v.451h.18v-.27h.361v.27h.721v-.451h-.451z",
    className: "prefix__cls-3",
    "data-name": "Path 360",
    transform: "translate(-165.465 -310.017)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_314",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 314",
    transform: "translate(10.006 8.654)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_315",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 315",
    transform: "translate(11.087 7.797)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_316",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 316",
    transform: "translate(9.735 7.797)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_361",
    d: "M447.527 170.141h-.135v-.541h-.18v.541h-.09v-.541h-.18v.27h-.542v.451h.451v-.18h-.27v-.09h.361v.27h.766v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 361",
    transform: "translate(-421.386 -169.6)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_362",
    d: "M421.78 174.58h.361v.27h.766v-.45h-.451v.18h.27v.09h-.406v-.27h-.72v.451h.18z",
    className: "prefix__cls-3",
    "data-name": "Path 362",
    transform: "translate(-397.983 -174.13)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_317",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 317",
    transform: "translate(23.617)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_318",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 318",
    transform: "translate(23.887 .541)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_319",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 319",
    transform: "translate(25.014 .856)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_320",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 320",
    transform: "translate(23.617 .856)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_321",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 321",
    transform: "translate(23.887 8.654)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_363",
    d: "M447.527 314.141h-.135v-.541h-.18v.541h-.09v-.541h-.18v.27h-.542v.451h.451v-.18h-.27v-.09h.361v.27h.766v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 363",
    transform: "translate(-421.386 -305.487)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_322",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 322",
    transform: "translate(23.617 8.113)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_364",
    d: "M422.456 318.58h.27v.09h-.406v-.27h-.72v.451h.18v-.27h.361v.27h.766v-.451h-.451z",
    className: "prefix__cls-3",
    "data-name": "Path 364",
    transform: "translate(-397.983 -310.017)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_323",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 323",
    transform: "translate(23.617 7.797)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_324",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 324",
    transform: "translate(25.014 7.797)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_365",
    d: "M471.38 174.58h.361v.27h.721v-.45h-.451v.18h.27v.09h-.361v-.27h-.72v.451h.18z",
    className: "prefix__cls-3",
    "data-name": "Path 365",
    transform: "translate(-444.789 -174.13)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_325",
    d: "M0 0H0.992V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 325",
    transform: "translate(26.411)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_326",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 326",
    transform: "translate(26.682 .541)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_327",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 327",
    transform: "translate(26.411 .856)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_366",
    d: "M472.011 318.58h.27v.09h-.361v-.27h-.72v.451h.18v-.27h.361v.27h.721v-.451h-.451z",
    className: "prefix__cls-3",
    "data-name": "Path 366",
    transform: "translate(-444.789 -310.017)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_328",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 328",
    transform: "translate(26.682 8.654)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_329",
    d: "M0 0H0.992V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 329",
    transform: "translate(26.411 8.113)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_330",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 330",
    transform: "translate(26.411 7.797)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_367",
    d: "M323.38 174.58h.361v.27h.721v-.45h-.451v.18h.27v.09h-.361v-.27h-.72v.451h.18z",
    className: "prefix__cls-3",
    "data-name": "Path 367",
    transform: "translate(-305.127 -174.13)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_368",
    d: "M349.082 170.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27H348v.451h.451v-.18h-.316v-.09h.406v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 368",
    transform: "translate(-328.529 -169.6)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_331",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 331",
    transform: "translate(18.344 .541)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_332",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 332",
    transform: "translate(18.073)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_333",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 333",
    transform: "translate(19.471 .856)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_334",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 334",
    transform: "translate(18.073 .856)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_335",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 335",
    transform: "translate(18.073 8.113)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_369",
    d: "M324.011 318.58h.27v.09h-.361v-.27h-.72v.451h.18v-.27h.361v.27h.721v-.451h-.451z",
    className: "prefix__cls-3",
    "data-name": "Path 369",
    transform: "translate(-305.127 -310.017)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_336",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 336",
    transform: "translate(18.344 8.654)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_370",
    d: "M349.082 314.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27H348v.451h.451v-.18h-.316v-.09h.406v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 370",
    transform: "translate(-328.529 -305.487)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_337",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 337",
    transform: "translate(18.073 7.797)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_338",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 338",
    transform: "translate(19.471 7.797)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_339",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 339",
    transform: "translate(20.823)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_371",
    d: "M397.927 170.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27h-.587v.451h.451v-.18h-.27v-.09h.406v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 371",
    transform: "translate(-374.58 -169.6)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_340",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 340",
    transform: "translate(21.138 .541)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_372",
    d: "M372.18 174.58h.406v.27h.721v-.45h-.451v.18h.27v.09h-.361v-.27H372v.451h.18z",
    className: "prefix__cls-3",
    "data-name": "Path 372",
    transform: "translate(-351.177 -174.13)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_341",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 341",
    transform: "translate(22.22 .856)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_342",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 342",
    transform: "translate(20.823 .856)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_373",
    d: "M372.856 318.58h.27v.09h-.361v-.27H372v.451h.18v-.27h.406v.27h.721v-.451h-.451z",
    className: "prefix__cls-3",
    "data-name": "Path 373",
    transform: "translate(-351.177 -310.017)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_343",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 343",
    transform: "translate(20.823 8.113)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_374",
    d: "M397.927 314.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27h-.587v.451h.451v-.18h-.27v-.09h.406v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 374",
    transform: "translate(-374.58 -305.487)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_344",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 344",
    transform: "translate(21.138 8.654)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_345",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 345",
    transform: "translate(20.823 7.797)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_346",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 346",
    transform: "translate(22.22 7.797)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_347",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 347",
    transform: "translate(4.146)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_348",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 348",
    transform: "translate(4.417 .541)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_375",
    d: "M76.18 174.58h.361v.27h.766v-.45h-.451v.18h.27v.09h-.406v-.27H76v.451h.18z",
    className: "prefix__cls-3",
    "data-name": "Path 375",
    transform: "translate(-71.854 -174.13)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_376",
    d: "M101.927 170.141h-.135v-.541h-.135v.541h-.135v-.541h-.18v.27h-.542v.451h.451v-.18h-.27v-.09h.361v.27h.766v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 376",
    transform: "translate(-95.256 -169.6)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_349",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 349",
    transform: "translate(4.146 .856)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_350",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 350",
    transform: "translate(5.544 .856)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_351",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 351",
    transform: "translate(4.146 8.113)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_377",
    d: "M76.856 318.58h.27v.09h-.406v-.27H76v.451h.18v-.27h.361v.27h.766v-.451h-.451z",
    className: "prefix__cls-3",
    "data-name": "Path 377",
    transform: "translate(-71.854 -310.017)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_352",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 352",
    transform: "translate(4.417 8.654)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_378",
    d: "M101.927 314.141h-.135v-.541h-.135v.541h-.135v-.541h-.18v.27h-.542v.451h.451v-.18h-.27v-.09h.361v.27h.766v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 378",
    transform: "translate(-95.256 -305.487)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_353",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 353",
    transform: "translate(4.146 7.797)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_354",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 354",
    transform: "translate(5.544 7.797)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_379",
    d: "M3.482 170.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27H2.4v.451h.451v-.18H2.58v-.09h.361v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 379",
    transform: "translate(-2.4 -169.6)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_355",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 355",
    transform: "translate(0 .856)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_380",
    d: "M3.482 314.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27H2.4v.451h.451v-.18H2.58v-.09h.361v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 380",
    transform: "translate(-2.4 -305.487)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_356",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 356",
    transform: "translate(0 7.797)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_357",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 357",
    transform: "translate(1.352)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_381",
    d: "M26.58 174.58h.406v.27h.721v-.45h-.451v.18h.27v.09h-.361v-.27H26.4v.451h.18z",
    className: "prefix__cls-3",
    "data-name": "Path 381",
    transform: "translate(-25.048 -174.13)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_358",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 358",
    transform: "translate(1.668 .541)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_382",
    d: "M52.327 170.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27H51.2v.451h.451v-.18h-.27v-.09h.406v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 382",
    transform: "translate(-48.451 -169.6)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_359",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 359",
    transform: "translate(2.749 .856)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_360",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 360",
    transform: "translate(1.352 .856)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_361",
    d: "M0 0H0.18V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 361",
    transform: "translate(1.668 8.654)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_362",
    d: "M0 0H1.848V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 362",
    transform: "translate(1.352 8.113)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_383",
    d: "M27.256 318.58h.27v.09h-.361v-.27H26.4v.451h.18v-.27h.406v.27h.721v-.451h-.451z",
    className: "prefix__cls-3",
    "data-name": "Path 383",
    transform: "translate(-25.048 -310.017)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_384",
    d: "M52.327 314.141h-.09v-.541h-.18v.541h-.09v-.541h-.18v.27H51.2v.451h.451v-.18h-.27v-.09h.406v.27h.721v-.721h-.18z",
    className: "prefix__cls-3",
    "data-name": "Path 384",
    transform: "translate(-48.451 -305.487)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_363",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 363",
    transform: "translate(2.749 7.797)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_364",
    d: "M0 0H1.307V0.18H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 364",
    transform: "translate(1.352 7.797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIran);
export default __webpack_public_path__ + "static/media/iran.41c2b1871b0f004b789a2aea72632335.svg";
export { ForwardRef as ReactComponent };